import cookie from "react-cookies";

import { useQuery } from "@tanstack/react-query";

import { userProfileApi } from "api";
import { TURNSTILE_COOKIE } from "config/cookies";
import { ApiQueryOptions } from "hooks/api/queryHelper";
import { transformToLoungePassClass } from "models/LoungePass";
import { resetTurnstileToken } from "utils/turnstile";

const fetchLoungePasses = async () => {
  const token = cookie.load(TURNSTILE_COOKIE);

  const [error, response] = await userProfileApi.fetchLoungePasses(token);

  if (error) {
    throw error;
  }

  resetTurnstileToken();

  return response;
};

const useFetchLoungePasses = (options: ApiQueryOptions = {}) => {
  return useQuery({
    queryKey: ["userProfile", "loungePasses"],
    queryFn: () => fetchLoungePasses(),
    select: (data) => data.loungePasses.map((loungePassData) => transformToLoungePassClass(loungePassData)),
    ...options,
  });
};

export default useFetchLoungePasses;
